import { styled } from '@stitches/react';

const SearchBar = styled('input', {
    type: 'text',
    border: '1px solid grey',
    borderRadius: '5px',
    height: '30px',
    width: '100%',
    padding: '2px 23px 2px 30px',
    outline: '0',
    backgroundColor: 'white',
    opacity: '1',
    fontSize: "20px",
    maxlength: "42"
})

export default SearchBar
